<div class="container-fluid">
  <div class="col-12 main_container">
    <div class="loginContainer">
      @if (!_successMessage) {
        <div class="form_center_reset">
          <div class="imagoLogin">
            <img src="/assets/menu/enterprise/logo-enterprise.svg" />
          </div>
          <h2 class="loginProjectTitle">password Requirements</h2>
          <div class="row">
            <div class="col-12">
              <div class="complexpassListContainer">
                @if (_passwordRequirements) {
                  <ul class="row complexpassList">
                    @for (req of _passwordRequirements | keyvalue; track req) {
                      <li
                        class="col-12 col-sm-6 reset-pasword-req-validation"
                        [class]="req.value.valid" [ngClass]="{'hide': req.value.text ==''}">
                        <span class="complexPasswordContainer-dot">.</span>
                        <span class="verifiedlogo">
                          <i class="fa fa-check" aria-hidden="true"></i>
                        </span>
                        <span class="not-validLogo">
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                        {{req.value.text}}
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
          <h2 class="loginProjectTitle margin_top_15">reset password</h2>
          <input type="password" [formControl]="_password" class="form-control" placeholder="Enter New Password" />
          <input type="password" [formControl]="_confirmPassword" class="form-control" placeholder="Confirm New Password" />
          <div class="centerDisplay">
            <button (click)="onSubmit()" class="commonBouttonStyle loginBtn">
              <span>
                <img class="loginIcons" src="/assets/menu/enterprise/reset-password-icon.svg" />
              </span>
              Reset Password
            </button>
          </div>
          @if (_resetRequiredMessage) {
            <div class="identity-invalid-feedback">
              <div>{{_resetRequiredMessage}}</div>
            </div>
          }
          @if (_errorMessage) {
            <div class="identity-invalid-feedback">
              <div>{{_errorMessage}}</div>
            </div>
          }
        </div>
      }

      @if (_successMessage) {
        <div class="form_center_reset">
          <div class="imagoLogin">
            <img src="/assets/menu/enterprise/logo-enterprise.svg" />
          </div>
          {{_successMessage}}
          <div class="borderSeparetor verificationSeperator"></div>
          <div class="emailVerificationText">
            * after resetting the password you will be logged-out from your
            account.please login with the new credentials submited
          </div>
          <div class="centerDisplay">
            <button (click)="onReturn()" class="commonBouttonStyle loginBtn margin_top_20">
              Return To Login
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
